// Placeholder for this likely becoming a list that drives a carousel in the attic section
const BANNER_CONTENT = {
  subtitle: "ThoughtSpot acquires Mode to define the next generation of collaborative BI >>",
  to: "https://mode.com/blog/thoughtspot-acquires-mode/",
  linkText: "Learn More"
};

export default BANNER_CONTENT;
